import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Add new Customer")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-section-title" }, [
              _createElementVNode("h5", null, "Customer config"),
              _createElementVNode("p", null, "Please ensure exact spelling if adding an existing company but under a different department")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "Customer name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.customer_name) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.customer_name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Department", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.customer_department) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.customer_department]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Country", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.country) = $event)),
                    class: "form-select"
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, "Select country", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: country,
                        key: country
                      }, _toDisplayString(country), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.country]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, "Save")
            ])
          ]))
    ])
  ]))
}